import { memoize, partialRight } from 'lodash';
import hash from 'object-hash';

export const memo = partialRight(memoize, (...args) => {
  const time = new Date().getMinutes();
  // using time as part of the cacheKey - so that we do not return very old results
  args.push({ time });

  const cacheKey = hash(args);
  return cacheKey;
});
